export default {
    ACTIVITY_ADDED: 'ACTIVITY_ADDED', // params (Activity)
    ACTIVITY_CHANGED: 'ACTIVITY_CHANGED', // params (Activity)
    MYFITNESSPAL_SETUP_COMPLETE: 'MYFITNESSPAL_SETUP_COMPLETE',
    ACTIVE_ACTIVITY_TRACKER_CHANGED: 'ACTIVE_ACTIVITY_TRACKER_CHANGED',
    SLEEP_WINDOW_CHANGED: 'SLEEP_WINDOW_CHANGED',
    SEGMENT_OPTED_IN_CHANGED: 'SEGMENT_OPTED_IN_CHANGED',
    FTP_WEIGHT_CHANGED: 'FTP_WEIGHT_CHANGED',
    PAGE_LOADED: 'PAGE_LOADED'
};
